import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import FallbackImage from './FallbackImage'
import useImageState from './useImageState'

export default function Image(props) {
  const { alt, className, decode, image, imageClassName, ...rest } = props

  const { getImageProps, state } = useImageState({ decode, image })
  const hasError = !state.isLoaded && !state.isLoading
  const isLoading = !state.isLoaded && state.isLoading

  const classes = cn(
    'c-image',
    {
      'has-error': hasError,
      'is-loading': isLoading,
    },
    className
  )

  const getContent = () => {
    if (state.isLoaded) {
      return <img className={imageClassName} alt={alt} {...getImageProps()} {...rest} />
    }
    if (isLoading) {
      // loading placeholder
    }
    if (hasError) {
      return <FallbackImage altText={alt} />
    }
    return null
  }

  return <div className={classes}>{getContent()}</div>
}

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  decode: PropTypes.bool,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  imageClassName: PropTypes.string,
}

Image.defaultProps = {
  className: '',
  decode: false,
  imageClassName: ''
}
